"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.personDeparturePlaceIsHome = exports.visitedPlacesIntro = exports.personDidTripsConfirm = exports.personDidTrips = exports.personWhoWillAnswerForThisPerson = exports.personNewPerson = exports.buttonSwitchPerson = exports.activePersonTitle = void 0;
const moment_1 = __importDefault(require("moment"));
const i18n_config_1 = __importDefault(require("evolution-frontend/lib/config/i18n.config"));
const escape_1 = __importDefault(require("lodash/escape"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const odSurveyHelper = __importStar(require("evolution-common/lib/services/odSurvey/helpers"));
const helpers_1 = require("evolution-common/lib/utils/helpers");
const validations = __importStar(require("evolution-common/lib/services/widgets/validations/validations"));
const project_config_1 = __importDefault(require("evolution-common/lib/config/project.config"));
const frontendHelper_1 = require("evolution-frontend/lib/services/display/frontendHelper");
const helper_1 = require("../../common/helper");
const widgetsSwitchPerson_1 = require("evolution-common/lib/services/questionnaire/sections/common/widgetsSwitchPerson");
const switchPersonWidgets = (0, widgetsSwitchPerson_1.getSwitchPersonWidgets)();
exports.activePersonTitle = switchPersonWidgets.activePersonTitle;
exports.buttonSwitchPerson = switchPersonWidgets.buttonSwitchPerson;
// FIXME This widget is custom because of the choices, conditional and label, it is also in the tripsSelectPeron
exports.personNewPerson = {
    type: 'question',
    inputType: 'button',
    path: 'household.persons.{_activePersonId}.journeys.{_activeJourneyId}._showNewPersonPopupButton',
    align: 'left',
    datatype: 'boolean',
    twoColumns: false,
    isModal: true,
    containsHtml: true,
    label: (t, interview) => {
        const activePerson = odSurveyHelper.getActivePerson({ interview });
        const nickname = (0, escape_1.default)(activePerson.nickname);
        return t('tripsIntro:_showNewPersonPopupButton', {
            nickname
        });
    },
    choices: [
        {
            value: false,
            label: (t) => t('customLabel:Continue'),
            color: 'green'
        },
        {
            // Keep this hidden `true` value so that the value is not reset when it is intialized to true (label and color do not matter)
            value: true,
            hidden: true
        }
    ],
    conditional: function (interview, path) {
        const interviewablePersons = odSurveyHelper.getInterviewablePersonsArray({ interview });
        const previousSections = (0, helpers_1.getResponse)(interview, '_sections._actions', []);
        // The last action is the start of this section, look at the before last section action and see if the section is `selectPerson`
        const manuallySelectedPerson = previousSections.length >= 2
            ? previousSections[previousSections.length - 2]['section'] === 'selectPerson'
            : false;
        const showPopup = (0, helpers_1.getResponse)(interview, path, true);
        // Show the popup if there are more than one interviewablePerson and
        // that person was not manually selected and the popup question is still
        // set to be displayed
        return [interviewablePersons.length > 1 && !manuallySelectedPerson && showPopup === true, false];
    }
};
// FIXME Custom because of the choices
exports.personWhoWillAnswerForThisPerson = {
    type: 'question',
    path: 'household.persons.{_activePersonId}.whoWillAnswerForThisPerson',
    inputType: 'radio',
    datatype: 'string',
    twoColumns: false,
    choices: function (interview) {
        const interviewablePersons = odSurveyHelper.getInterviewablePersonsArray({ interview });
        return interviewablePersons
            .filter((person) => person.age >= project_config_1.default.selfResponseMinimumAge)
            .map((person) => ({
            value: person._uuid,
            label: person.nickname
        }));
    },
    sameLine: false,
    label: (t, interview) => {
        const activePerson = odSurveyHelper.getActivePerson({ interview });
        return t('tripsIntro:whoAnswers', {
            nickname: activePerson.nickname
        });
    },
    conditional: function (interview, path) {
        const interviewablePersons = odSurveyHelper.getInterviewablePersonsArray({ interview });
        const canRespondPersons = interviewablePersons.filter((person) => person.age >= project_config_1.default.selfResponseMinimumAge);
        return [canRespondPersons.length > 1, canRespondPersons.length === 1 ? canRespondPersons[0]._uuid : null];
    },
    validations: validations.requiredValidation
};
// FIXME Custom because of the label with date and other placeholders
exports.personDidTrips = {
    type: 'question',
    path: 'household.persons.{_activePersonId}.journeys.{_activeJourneyId}.personDidTrips',
    inputType: 'radio',
    datatype: 'string',
    twoColumns: false,
    containsHtml: true,
    label: (t, interview) => {
        const activePerson = odSurveyHelper.getActivePerson({ interview });
        const nickname = (0, escape_1.default)((activePerson === null || activePerson === void 0 ? void 0 : activePerson.nickname) || t('survey:noNickname'));
        const assignedDay = (0, helpers_1.getResponse)(interview, '_assignedDay');
        const assignedDate = (0, frontendHelper_1.getFormattedDate)(assignedDay, { withDayOfWeek: true, withRelative: true });
        return t('tripsIntro:personDidTrips', {
            context: (activePerson === null || activePerson === void 0 ? void 0 : activePerson.gender) || (activePerson === null || activePerson === void 0 ? void 0 : activePerson.sexAssignedAtBirth),
            nickname,
            assignedDate,
            count: odSurveyHelper.getCountOrSelfDeclared({ interview, person: activePerson })
        });
    },
    helpPopup: {
        containsHtml: true,
        title: (t, interview) => {
            const assignedDay = (0, helpers_1.getResponse)(interview, '_assignedDay');
            return t('customLabel:WhyThisDate');
        },
        content: (t, interview) => t('customLabel:WhyThisDateExplanation')
    },
    choices: [
        {
            value: 'yes',
            label: {
                fr: 'Oui',
                en: 'Yes'
            }
        },
        {
            value: 'no',
            label: {
                fr: 'Non',
                en: 'No'
            }
        },
        {
            value: 'dontKnow',
            label: {
                fr: 'Je ne sais pas',
                en: 'I don\'t know'
            },
            conditional: function (interview, path) {
                // FIXME originally, this appeared also for interviewers, but we won't have interviewers for this survey. or do we want to support it?
                return project_config_1.default.acceptUnknownDidTrips;
            }
        }
    ],
    validations: validations.requiredValidation
};
// FIXME Custom because of the labels with date and other placeholders, as well as the choices labels
exports.personDidTripsConfirm = {
    type: 'question',
    path: 'household.persons.{_activePersonId}.journeys.{_activeJourneyId}.personDidTripsConfirm',
    inputType: 'radio',
    datatype: 'string',
    twoColumns: false,
    sameLine: false,
    label: (t, interview) => {
        const activePerson = odSurveyHelper.getActivePerson({ interview });
        const tripsDate = (0, helpers_1.getResponse)(interview, '_assignedDay', null);
        const formattedTripsDate = (0, frontendHelper_1.getFormattedDate)(tripsDate, { withRelative: true, locale: i18n_config_1.default.language });
        return t('tripsIntro:personDidTripsConfirm', {
            count: odSurveyHelper.getCountOrSelfDeclared({ interview, person: activePerson }),
            nickname: (activePerson === null || activePerson === void 0 ? void 0 : activePerson.nickname) || t('survey:noNickname'),
            context: (activePerson === null || activePerson === void 0 ? void 0 : activePerson.gender) || (activePerson === null || activePerson === void 0 ? void 0 : activePerson.sexAssignedAtBirth),
            formattedTripsDate
        });
    },
    choices: [
        {
            value: 'no',
            label: (t, interview) => {
                const activePerson = odSurveyHelper.getActivePerson({ interview });
                const tripsDate = (0, helpers_1.getResponse)(interview, '_assignedDay', null);
                const formattedTripsDate = (0, frontendHelper_1.getFormattedDate)(tripsDate, {
                    withRelative: true,
                    locale: i18n_config_1.default.language
                });
                return t('tripsIntro:personDidTripsConfirmChoiceNo', {
                    count: odSurveyHelper.getCountOrSelfDeclared({ interview, person: activePerson }),
                    nickname: activePerson.nickname,
                    assignedDate: formattedTripsDate
                });
            }
        },
        {
            value: 'yes',
            label: (t, interview) => {
                const activePerson = odSurveyHelper.getActivePerson({ interview });
                const tripsDate = (0, helpers_1.getResponse)(interview, '_assignedDay', null);
                const formattedTripsDate = (0, frontendHelper_1.getFormattedDate)(tripsDate, {
                    withRelative: true,
                    locale: i18n_config_1.default.language
                });
                return t('tripsIntro:personDidTripsConfirmChoiceYes', {
                    count: odSurveyHelper.getCountOrSelfDeclared({ interview, person: activePerson }),
                    nickname: activePerson.nickname,
                    assignedDate: formattedTripsDate
                });
            }
        }
    ],
    conditional: function (interview, path) {
        const activeJourney = odSurveyHelper.getActiveJourney({ interview });
        if (activeJourney === null) {
            return [false, null];
        }
        const personDidTrips = (0, helpers_1.getResponse)(interview, path, null, '../personDidTrips');
        const visitedPlaces = odSurveyHelper.getVisitedPlacesArray({
            journey: activeJourney
        });
        if ((0, LodashExtensions_1._isBlank)(personDidTrips)) {
            return [false, null];
        }
        return [(0, LodashExtensions_1._booleish)(personDidTrips) === false && visitedPlaces.length > 1, null];
    },
    validations: validations.requiredValidation
};
// FIXME Custom because of the label with date
exports.visitedPlacesIntro = {
    type: 'text',
    path: 'visitedPlacesIntro',
    containsHtml: true,
    text: (t, interview) => {
        const activePerson = odSurveyHelper.getActivePerson({ interview });
        const nickname = (0, escape_1.default)((activePerson === null || activePerson === void 0 ? void 0 : activePerson.nickname) || t('survey:noNickname'));
        const tripsDate = (0, helpers_1.getResponse)(interview, '_assignedDay', null);
        const formattedTripsDate = (0, frontendHelper_1.getFormattedDate)(tripsDate, { withRelative: true, locale: i18n_config_1.default.language });
        return t('tripsIntro:didTripsIntro', {
            context: (activePerson === null || activePerson === void 0 ? void 0 : activePerson.gender) || (activePerson === null || activePerson === void 0 ? void 0 : activePerson.sexAssignedAtBirth),
            nickname,
            assignedDate: formattedTripsDate,
            count: odSurveyHelper.getCountOrSelfDeclared({ interview, person: activePerson })
        });
    },
    conditional: function (interview, path) {
        const journey = odSurveyHelper.getActiveJourney({ interview });
        return [
            (0, LodashExtensions_1._booleish)(journey.personDidTrips) || (0, LodashExtensions_1._booleish)(journey.personDidTripsConfirm),
            undefined
        ];
    }
};
// FIXME Custom because of the label with date and other placeholders, the conditional (but we could use customConditional) and the required validation text
exports.personDeparturePlaceIsHome = {
    type: 'question',
    path: 'household.persons.{_activePersonId}.journeys.{_activeJourneyId}.departurePlaceIsHome',
    inputType: 'radio',
    datatype: 'string',
    twoColumns: false,
    containsHtml: true,
    choices: [
        {
            value: 'yes',
            label: (t) => t('survey:Yes')
        },
        {
            value: 'no',
            label: (t) => t('survey:No')
        }
    ],
    sameLine: false,
    label: (t, interview) => {
        const activePerson = odSurveyHelper.getActivePerson({ interview });
        const nickname = (0, escape_1.default)((activePerson === null || activePerson === void 0 ? void 0 : activePerson.nickname) || t('survey:noNickname'));
        const assignedDay = (0, moment_1.default)((0, helpers_1.getResponse)(interview, '_assignedDay'));
        const dayBefore = (0, moment_1.default)(assignedDay).subtract(1, 'days');
        const homeAddress = (0, escape_1.default)((0, helper_1.getHomeAddressOneLine)(interview));
        const dayBeforeStr = dayBefore
            .toDate()
            .toLocaleDateString(i18n_config_1.default.language, { weekday: 'long', month: 'long', day: 'numeric' });
        const assignedDayStr = assignedDay
            .toDate()
            .toLocaleDateString(i18n_config_1.default.language, { weekday: 'long', month: 'long', day: 'numeric' });
        return t('tripsIntro:departurePlaceIsHome', {
            context: (activePerson === null || activePerson === void 0 ? void 0 : activePerson.gender) || (activePerson === null || activePerson === void 0 ? void 0 : activePerson.sexAssignedAtBirth),
            nickname,
            dayOne: dayBeforeStr,
            dayTwo: assignedDayStr,
            address: homeAddress,
            count: odSurveyHelper.getCountOrSelfDeclared({ interview, person: activePerson })
        });
    },
    conditional: function (interview, path) {
        const journey = odSurveyHelper.getActiveJourney({ interview });
        const departurePlaceIsHome = (0, helpers_1.getResponse)(interview, path, null);
        const firstVisitedPlace = odSurveyHelper.getVisitedPlacesArray({ journey })[0];
        const personDidTrips = journey.personDidTrips;
        const personDidTripsConfirm = journey.personDidTripsConfirm;
        if ((0, LodashExtensions_1._booleish)(personDidTrips) !== true ||
            ((0, LodashExtensions_1._isBlank)(personDidTrips) && (0, LodashExtensions_1._booleish)(personDidTripsConfirm) === false)) {
            return [false, null];
        }
        else if (firstVisitedPlace && (firstVisitedPlace.activity || firstVisitedPlace.activityCategory)) {
            return [false, firstVisitedPlace.activity === 'home' ? 'yes' : 'no'];
        }
        else if ((0, LodashExtensions_1._isBlank)(personDidTrips)) {
            return [false, departurePlaceIsHome];
        }
        return [true, departurePlaceIsHome];
    },
    validations: function (value) {
        return [
            {
                validation: (0, LodashExtensions_1._isBlank)(value),
                errorMessage: (t) => t('survey:visitedPlace:departurePlaceIsRequiredError')
            }
        ];
    }
};
